export class FilterActivePhaseViewModel {
  CompanyId: any;
  ContractId: any;
  JobScheduleId?: any;
  Item: any;
}

export class SelectedJobs {
  startDate!: Date;
  companyId: any;
  ActivePhase!: ActivePhase[];
  // Employee: Employee[];
}

export class ActivePhase {
  description!: string;
  estHours!: number | null;
  estLaborProd: any;
  estLaborUnits!: number | null;
  isActive!: boolean;
  isDeleted!: boolean;
  item: any;
  jobId: any;
  phaseGroupId: any;
  phaseId: any;
  um: any;
  expProd: any;
  isAdded!: boolean;
  employees!: string;
  employeesFullName!: string;
  workForce!: Employee[];
  currentCompanyWorkForce!: Employee[];
  allWorkForce!: Employee[];
  bidHrs!: string;
  jtdHrs!: string;
  remHrs!: string;
}

export class Employee {
  companyId!: number;
  employeeId!: number;
  hrCompany!: number;
  hrRef!: number;
  payRollCompany!: number;
  lastName!: string;
  firstName!: string;
  middleName!: string;
  suffix!: string;
  sortName!: string;
  isActive!: boolean;
  positionCode!: string;
  jobTitle!: string;
  workPhone!: string;
  isDeleted!: boolean;
  isAdded!: boolean;
  worksFor: any;
  phaseId: any;
  isAssigned!: boolean;
  assignedJobs!: string;
  hRCompanyName!: string;
  payRollCompanyName!: string;
  fullNameForDisplayInGrid!: string;
  fullNameForSort!: string;
  worksForCompanyName!: string;
}

export class AuditHistoryViewModel {
  auditHistoryId: any;
  actionType!: number;
  actionTypeName!: string;
  objectId: any;
  text!: string;
  createdBy!: string;
  createdDate: any;
  createdByName!: string;
}
